export default __webpack_public_path__ + "static/81495-2a35fe491ca1dc73fb53f62bacbb4c9d.jpg";